<ng-container *ngIf="appModeService.isApp(); else webCartFallback">
    <section class="checkout-page">
        <ng-container *ngIf="items$ | async as items">

            <!-- Order Summary -->
            <section class="order-summary" *ngIf="items.length > 0">
                <div class="summary-card">
                    <div class="summary-header" (click)="toggleSummary()">
                        <div class="summary-header-left">
                            <i class="bi bi-bag"></i>
                            <div>
                                <span class="summary-title">{{ 'APP.ORDER_SUMMARY' | translate }}</span>
                                <span class="summary-preview">
                                    {{ items.length }} items · {{ (totalToPay$ | async) || 0 |
                                    currency:'EGP':'symbol':'1.0-0' }}
                                </span>
                            </div>
                        </div>
                        <i class="bi bi-chevron-down arrow-icon" [class.rotated]="summaryOpen"></i>
                    </div>

                    <div class="summary-body" [class.open]="summaryOpen">
                        <div *ngFor="let item of items; trackBy: trackByItem; let last = last">
                            <div class="item-row">
                                <img [src]="item.imageUrl" [alt]="item.title" class="item-img" />
                                <div class="item-info">
                                    <div class="item-title">{{ item.title }}</div>
                                    <div class="item-variant">{{ item.variant }}</div>
                                </div>
                                <div class="item-right">
                                    <span class="item-price">{{ item.price * item.quantity |
                                        currency:'EGP':'symbol':'1.0-0' }}</span>
                                    <span class="qty-badge">×{{ item.quantity }}</span>
                                </div>
                            </div>
                            <div class="item-divider" *ngIf="!last"></div>
                        </div>
                        <div class="totals-section">
                            <div class="total-row grand">
                                <span>{{ 'APP.TOTAL' | translate }}</span>
                                <span>{{ (totalToPay$ | async) || 0 | currency:'EGP':'symbol':'1.0-0' }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- ══════════════════════════════════════
     LOGGED IN USER
══════════════════════════════════════ -->
            <ng-container *ngIf="authStatus === 'loggedIn'">

                <!-- Section header -->
                <div class="section-header">
                    <span class="form-section-title mb-0">{{ 'CHECKOUT_DELIVERY_ADDRESS' | translate }}</span>
                    <button class="add-address-btn" type="button" (click)="toggleAddressForm()">
                        <i class="bi" [class.bi-plus]="!showAddressForm" [class.bi-x]="showAddressForm"></i>
                        {{ (showAddressForm ? 'CHECKOUT_CANCEL' : 'CHECKOUT_ADD_ADDRESS') | translate }}
                    </button>
                </div>

                <!-- Existing addresses list -->
                <div class="address-list" *ngIf="userAddresses.length > 0">
                    <ng-container *ngFor="let addr of userAddresses; let last = last">
                        <div class="address-option" [class.selected]="selectedAddressId === addr.id && !showAddressForm"
                            (click)="selectAddress(addr.id)">
                            <span class="address-option-text">
                                {{ addr.streetAddress }}, {{ addr.region }}, {{ addr.city }}
                            </span>
                            <span class="address-check" *ngIf="selectedAddressId === addr.id && !showAddressForm">
                                <i class="bi bi-check-circle-fill"></i>
                            </span>
                        </div>
                        <div class="field-divider" *ngIf="!last"></div>
                    </ng-container>
                </div>

                <!-- No addresses -->
                <div class="no-address-msg" *ngIf="userAddresses.length === 0 && !showAddressForm">
                    <p>{{ 'CHECKOUT_NO_ADDRESS' | translate }}</p>
                </div>

                <!-- Add new address form -->
                <div class="address-card new-address-card" *ngIf="showAddressForm">

                    <div class="field-row" [class.field-error]="isInvalid('streetAddress', addressForm)">
                        <input [formControl]="$any(addressForm.get('streetAddress'))" type="text"
                            [placeholder]="'FIELD_STREET' | translate" class="field-input" />
                        <span class="validation-msg" *ngIf="isInvalid('streetAddress', addressForm)">
                            {{ 'VALIDATION_REQUIRED' | translate }}
                        </span>
                    </div>
                    <div class="field-divider"></div>

                    <div class="field-row" [class.field-error]="isInvalid('region', addressForm)">
                        <input [formControl]="$any(addressForm.get('region'))" type="text"
                            [placeholder]="'FIELD_REGION' | translate" class="field-input" />
                        <span class="validation-msg" *ngIf="isInvalid('region', addressForm)">
                            {{ 'VALIDATION_REQUIRED' | translate }}
                        </span>
                    </div>
                    <div class="field-divider"></div>

                    <div class="field-row" [class.field-error]="isInvalid('city', addressForm)">
                        <input [formControl]="$any(addressForm.get('city'))" type="text"
                            [placeholder]="'FIELD_CITY' | translate" class="field-input" />
                        <span class="validation-msg" *ngIf="isInvalid('city', addressForm)">
                            {{ 'VALIDATION_REQUIRED' | translate }}
                        </span>
                    </div>
                    <div class="field-divider"></div>

                    <div class="field-row">
                        <input [formControl]="$any(addressForm.get('postalCode'))" type="text"
                            [placeholder]="'FIELD_POSTAL_CODE' | translate" class="field-input" />
                    </div>

                    <!-- Save address button inside the card -->
                    <div class="address-form-footer">
                        <button type="button" class="save-address-btn" [disabled]="isSavingAddress"
                            (click)="saveNewAddress()">
                            <span *ngIf="!isSavingAddress">{{ 'CHECKOUT_SAVE_ADDRESS' | translate }}</span>
                            <span *ngIf="isSavingAddress">{{ 'CHECKOUT_SAVING' | translate }}</span>
                        </button>
                    </div>

                </div>

                <!-- Payment Method -->
                <div class="form-section-title">{{ 'CHECKOUT_PAYMENT_METHOD' | translate }}</div>
                <div class="payment-card">
                    <ng-container *ngFor="let opt of paymentOptions; let last = last">
                        <div class="payment-option" [class.selected]="selectedPayment === opt.value"
                            (click)="selectPayment(opt.value)">
                            <span class="payment-label">{{ opt.labelKey | translate }}</span>
                            <span class="payment-check" *ngIf="selectedPayment === opt.value">
                                <i class="bi bi-check-circle-fill"></i>
                            </span>
                        </div>
                        <div class="field-divider" *ngIf="!last"></div>
                    </ng-container>
                </div>

                <!-- Instructions -->
                <div class="form-section-title">
                    {{ 'CHECKOUT_INSTRUCTIONS' | translate }}
                    <span class="optional-tag">{{ 'CHECKOUT_INSTRUCTIONS_OPTIONAL' | translate }}</span>
                </div>
                <div class="address-card">
                    <div class="field-row">
                        <textarea [(ngModel)]="authInstructions" class="field-input instructions-input"
                            [placeholder]="'CHECKOUT_INSTRUCTIONS_PLACEHOLDER' | translate" rows="3"></textarea>
                    </div>
                </div>

                <!-- Submit -->
                <button class="submit-btn" type="button" [disabled]="isSubmitting" (click)="submitAuthOrder(items)">
                    {{ (isSubmitting ? 'CHECKOUT_PLACING_ORDER' : 'CHECKOUT_PLACE_ORDER') | translate }}
                </button>

            </ng-container>
            <!-- ══════════════════════════════════════
           GUEST USER
      ══════════════════════════════════════ -->
            <ng-container *ngIf="authStatus === 'guest' && !authModal">
                <form [formGroup]="guestForm" (ngSubmit)="submitGuestOrder(items)" novalidate>

                    <!-- Delivery Address -->
                    <div class="form-section-title">{{ 'CHECKOUT_DELIVERY_ADDRESS' | translate }}</div>
                    <div class="address-card">

                        <div class="field-row" [class.field-error]="isInvalid('streetAddress')">
                            <input formControlName="streetAddress" type="text"
                                [placeholder]="'FIELD_STREET' | translate" class="field-input" />
                            <span class="validation-msg" *ngIf="isInvalid('streetAddress')">
                                {{ 'VALIDATION_REQUIRED' | translate }}
                            </span>
                        </div>
                        <div class="field-divider"></div>

                        <div class="field-row" [class.field-error]="isInvalid('region')">
                            <input formControlName="region" type="text" [placeholder]="'FIELD_REGION' | translate"
                                class="field-input" />
                            <span class="validation-msg" *ngIf="isInvalid('region')">
                                {{ 'VALIDATION_REQUIRED' | translate }}
                            </span>
                        </div>
                        <div class="field-divider"></div>

                        <div class="field-row" [class.field-error]="isInvalid('city')">
                            <input formControlName="city" type="text" [placeholder]="'FIELD_CITY' | translate"
                                class="field-input" />
                            <span class="validation-msg" *ngIf="isInvalid('city')">
                                {{ 'VALIDATION_REQUIRED' | translate }}
                            </span>
                        </div>
                        <div class="field-divider"></div>

                        <div class="field-row">
                            <input formControlName="postalCode" type="text"
                                [placeholder]="'FIELD_POSTAL_CODE' | translate" class="field-input" />
                        </div>

                    </div>

                    <!-- Contact Info -->
                    <div class="form-section-title">{{ 'CHECKOUT_CONTACT_INFO' | translate }}</div>
                    <div class="address-card">

                        <div class="field-row" [class.field-error]="isInvalid('name')">
                            <input formControlName="name" type="text" [placeholder]="'FIELD_NAME' | translate"
                                class="field-input" />
                            <span class="validation-msg" *ngIf="isInvalid('name')">
                                {{ 'VALIDATION_REQUIRED' | translate }}
                            </span>
                        </div>
                        <div class="field-divider"></div>

                        <div class="field-row" [class.field-error]="isInvalid('email')">
                            <input formControlName="email" type="email" [placeholder]="'FIELD_EMAIL' | translate"
                                class="field-input" />
                            <span class="validation-msg" *ngIf="isInvalid('email')">
                                <ng-container *ngIf="guestForm.get('email')?.errors?.['required']">
                                    {{ 'VALIDATION_REQUIRED' | translate }}
                                </ng-container>
                                <ng-container *ngIf="guestForm.get('email')?.errors?.['email']">
                                    {{ 'VALIDATION_EMAIL_INVALID' | translate }}
                                </ng-container>
                            </span>
                        </div>
                        <div class="field-divider"></div>

                        <!-- Phone with country code -->
                        <div class="field-row phone-row" [class.field-error]="isInvalid('phoneNumber')">
                            <div class="phone-field-wrapper">

                                <div class="country-selector" (click)="toggleCountryDropdown($event)">
                                    <span class="country-code-text">{{ selectedCountry.code }}</span>
                                    <i class="bi bi-chevron-down country-arrow"
                                        [class.rotated]="countryDropdownOpen"></i>
                                </div>

                                <div class="phone-divider"></div>

                                <input formControlName="phoneNumber" type="tel"
                                    [placeholder]="'FIELD_PHONE' | translate" class="field-input phone-input"
                                    (click)="$event.stopPropagation()" />

                                <!-- Dropdown -->
                                <div class="country-dropdown" [class.open]="countryDropdownOpen">
                                    <div *ngFor="let c of countries" class="country-option"
                                        (click)="selectCountry(c, $event)">
                                        <span class="country-option-name">{{ c.name }}</span>
                                        <span class="country-option-code">{{ c.code }}</span>
                                    </div>
                                </div>

                            </div>

                            <span class="validation-msg" *ngIf="isInvalid('phoneNumber')">
                                <ng-container *ngIf="guestForm.get('phoneNumber')?.errors?.['required']">
                                    {{ 'VALIDATION_REQUIRED' | translate }}
                                </ng-container>
                                <ng-container *ngIf="guestForm.get('phoneNumber')?.errors?.['pattern']">
                                    {{ 'VALIDATION_PHONE_INVALID' | translate }}
                                </ng-container>
                            </span>
                        </div>

                    </div>

                    <!-- Payment Method -->
                    <div class="form-section-title">{{ 'CHECKOUT_PAYMENT_METHOD' | translate }}</div>
                    <div class="payment-card">
                        <ng-container *ngFor="let opt of paymentOptions; let last = last">
                            <div class="payment-option"
                                [class.selected]="guestForm.get('paymentMethod')?.value === opt.value"
                                (click)="selectPayment(opt.value)">
                                <span class="payment-label">{{ opt.labelKey | translate }}</span>
                                <span class="payment-check" *ngIf="guestForm.get('paymentMethod')?.value === opt.value">
                                    <i class="bi bi-check-circle-fill"></i>
                                </span>
                            </div>
                            <div class="field-divider" *ngIf="!last"></div>
                        </ng-container>
                    </div>

                    <!-- Instructions -->
                    <div class="form-section-title">
                        {{ 'CHECKOUT_INSTRUCTIONS' | translate }}
                        <span class="optional-tag">{{ 'CHECKOUT_INSTRUCTIONS_OPTIONAL' | translate }}</span>
                    </div>
                    <div class="address-card">
                        <div class="field-row">
                            <textarea formControlName="instructions" class="field-input instructions-input"
                                [placeholder]="'CHECKOUT_INSTRUCTIONS_PLACEHOLDER' | translate" rows="3"></textarea>
                        </div>
                    </div>

                    <!-- Submit -->
                    <button type="submit" class="submit-btn" [disabled]="isSubmitting">
                        {{ (isSubmitting ? 'CHECKOUT_PLACING_ORDER' : 'CHECKOUT_PLACE_ORDER') | translate }}
                    </button>

                </form>
            </ng-container>

        </ng-container>
    </section>
</ng-container>



<ng-template #webCartFallback>
    <div class="container py-5">
        <h1 class="main-title">Cart</h1>
        <p>Please use the mobile app view for the full cart experience.</p>
    </div>
</ng-template>

<!-- Auth Modal -->
<div class="auth-modal" *ngIf="authStatus == 'guest' && authModal">
    <div class="modal">
        <p>{{ 'CHECKOUT_AUTH_MODAL_TITLE' | translate }}</p>
        <button (click)="continueAsGuest()">
            <i class="bi bi-person"></i>
            {{ 'CONTINUE_AS_GUEST' | translate }}
        </button>
        <button (click)="goToLogin()">
            <i class="bi bi-box-arrow-in-right"></i>
            {{ 'SIGN_IN_OR_CREATE_ACCOUNT' | translate }}
        </button>
    </div>
</div>